import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.materials && _vm.materials.records)?_c(VRow,{staticClass:"materials"},_vm._l((_vm.materials.records),function(material){return _c(VCol,{key:material.id,attrs:{"lg":"3","cols":"12","md":"4","sm":"6"}},[_c('MaterialCard',{attrs:{"material":material,"handle-material-click":_vm.handleMaterialClick}})],1)}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }